/*
 *  Document   : consultant_candidates_edit.js
 *  Author     : Exapoint
 *
 */

// Import required modules
import ExaHelpers from "../exa_helpers";
import CandidateProfessions from "./candidate-professions";


export default class ConsultantCandidatesEdit {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ConsultantCandidatesEdit"] = this;
        this.init();

        if (CandidateProfessions) {
            CandidateProfessions.consultant = this;
        }
    }

    init() {
        $('a.nav-link').on('shown.bs.tab', function (e) {
            this.initTabByHash(e.target.href.split("#")[1]);
        }.bind(this));

        if (window.location.hash) {
            this.initTabByHash(window.location.hash.substr(1));
        } else {
            this.initTabByHash($('.nav-item a.nav-link').first().prop('href').split("#")[1]);
        }

        this.professionsTabInit = false;

        this.initDisableUserButtons();
    }

    initTabByHash(hash) {
        if (hash === "missions") {
            this.initMissionsTab();
        } else if (hash === "ratings") {
            this.initRatingsTab();
        } else if (hash === "logins") {
            this.initLoginsTab();
        } else if (hash === "notes") {
            this.initNotesTab();
        } else if (hash === "professions") {
            this.initProfessionsTab();
        }
    }

    initMissionsTab() {
        this.missionsTable = this.missionsTable || $('#missions .js-dataTable-full-pagination').DataTable({
            ajax: missionsDataUrl,
            ordering: false,
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {
                    data: "mission.professions",
                    render: function (data, type, row) {
                        let html= "";

                        if (row.mission.titre) {
                            html = `<a href="${jsVars.editMissionUrl.replace(':mission-id', row.mission.id)}">${row.mission.titre ?? ""}<br />${data}</a>`;
                        }else{
                            html = `<a href="${jsVars.editMissionUrl.replace(':mission-id', row.mission.id)}">${data}</a>`;
                        }

                        if (row.mission.end_mission_reason_id) {
                            html += `<span class="ml-2 badge badge-pill badge-danger">${jsVars.archivedText}</span>`;
                        }
                        return html;
                    }
                },
                {
                    data: "mission.start_date",
                    render: function (data, type, row) {
                        let startDate = new Date(row.mission.start_date);
                        let endDate = new Date(row.mission.end_date);

                        startDate = ExaHelpers.isValidDate(startDate) ? ExaHelpers.formatDateWithLocale(startDate) : '';
                        if (ExaHelpers.isValidDate(endDate)) {
                            if (endDate.getFullYear() === 9999) {
                                endDate = jsVars.noEndDate;
                            } else {
                                endDate = ExaHelpers.formatDateWithLocale(endDate);
                            }
                        } else {
                            endDate = '';
                        }
                        return [startDate, endDate].filter(Boolean).join("<br>");
                    }
                },
                {data: "response_type.description"},
                {data: "match_status.description"},
            ],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true
        });
    }

    initNotesTab() {
        window.notesTable = typeof notesTable != "undefined" ? notesTable : $('#notes .js-dataTable-full-pagination').DataTable({
            ajax: notesDataUrl,
            order: [[2, "desc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {
                    data: "note",
                    render: function (data, type, row) {
                        let txt = document.createElement("textarea");
                        txt.innerHTML = data;
                        return `${txt.value} <input type="hidden" name="note" value="${txt.value}">`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        return `
                        <span data-toggle="modal" data-target="#notes-edit-modal">
                            <div class="btn btn-outline-primary btn-small" data-toggle="tooltip" title="${jsVars.edit}">
                                <i class="fa fa-pencil-alt"></i>
                            </div>
                        </span>
                        <input type="hidden" name="id" value="${row.id}"/>
                    `;

                    }
                },
                {
                    data: "updated_at",
                    render: function (data, type, row) {
                        return new Date(data).toLocaleString('de-CH');
                    }
                },
            ],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true
        });

        let $notesModal = $('#notes-edit-modal');
        ExaHelpers.initCrudAjaxModal(
            $notesModal,
            {
                datatablesApi: notesTable,
                ajaxUrl: notesCreateUrl,
                $form: $notesModal.find('form'),
                updateTitle: false,
            }
        );

        this.$newNoteInput = this.$newNoteInput || $('#new-note-summernote');
        if (typeof this.$newNoteInput.data().summernote == "undefined") {
            ExaHelpers.summernoteBySelector('#' + this.$newNoteInput.prop('id'));
        }

        $notesModal.on('hidden.bs.modal', function (e) {
            $notesModal.find('.summernote').summernote('reset');
            $notesModal.find('input:not([name="_token"])').val('');
        });
    }

    initRatingsTab() {
        this.ratingsTable = this.ratingsTable || $('#ratings .js-dataTable-full-pagination').DataTable({
            ajax: ratingsDataUrl,
            order: [[1, "asc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {
                    data: "submitter_id",
                    render: function (data, type, row) {
                        //return `${data ?? ""}`;
                        return `${row.submitter.first_name} ${row.submitter.last_name}`;
                    }
                },
                {
                    data: "total",
                    render: function (data, type, row) {
                        if(data == -1){
                            return `ne s'est pas présenté(e)`;
                        }else{
                           return `${ExaHelpers.ratingToIcons(data)}`;
                        }
                    }
                },
                {
                    data: "presentation_rating_id",
                    render: function (data, type, row) {
                        return `${ExaHelpers.ratingToIcons(data)}`;
                    }
                },
                {
                    data: "punctuality_rating_id",
                    render: function (data, type, row) {
                        return `${ExaHelpers.ratingToIcons(data)}`;
                    }
                },
                {
                    data: "competence_rating_id",
                    render: function (data, type, row) {
                        return `${ExaHelpers.ratingToIcons(data)}`;
                    }
                },
                {
                    data: "comment",
                    render: function (data, type, row) {
                        //return `${ExaHelpers.ratingToIcons(data)}`;
                        return `${data ?? ""}`;
                    }
                },
                {
                    data: "updated_at",
                    render: function (data, type, row) {
                        return ExaHelpers.formatDateTimeWithLocale(new Date(data), jsVars.labelBetween);
                    }
                },
            ],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true
        });
    }

    initLoginsTab() {
        this.loginsTable = this.loginsTable || $('#logins .js-dataTable-full-pagination').DataTable({
            ajax: loginsDataUrl,
            order: [[0, "asc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {data: "id"},
                {data: "description"},
                {
                    data: "updated_at",
                    render: function (data, type, row) {
                        return new Date(data).toLocaleString('de-CH');
                    }
                },
            ],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true
        });
    }

    initProfessionsTab() {
        let $professionsTable = $('table.professions');
        if ($professionsTable.hasClass('dataTable')) {
            $professionsTable.DataTable().responsive.recalc();
        }

        if (this.professionsTabInit) {
            return;
        }
        this.professionsTabInit = true;

        this.$professionsEditModal = $('#professions-edit-modal');
        this.initProfessionsDropzone();

        $professionsTable.DataTable().on('responsive-display', function (e, datatable, row, showHide, update) {
            if (row.selector.rows && typeof row.selector.rows.length !== "undefined") {
                $.each(row.selector.rows.find('.custom-control'), function (index, value) {
                    let $el = $(value);
                    let newName = Math.random().toString(36).substring(7);

                    $el.find('label').prop('for', newName);
                    $el.find('input').prop('id', newName);
                });
            }
        });

        $professionsTable.on('change', 'tr.child .custom-control-input', function (e) {
            let $el = $(e.target);
            $('[name="' + $el.prop('name') + '"]').prop('checked', $el.prop('checked'));
        })
    }

    statusColumn(datarecord) {
        return `
            <div class="status-checkbox">
                <div class="custom-control custom-switch">
                    <input class="custom-control-input" id="userable[jobTitles][${datarecord.id}][verification_status_id]" name="userable[jobTitles][${datarecord.id}][verification_status_id]" type="checkbox" value="5">
                    <label for="userable[jobTitles][${datarecord.id}][verification_status_id]" class="custom-control-label verified" style="display:none;">${jsVars.verifiedStatusLabel}</label>
                    <label for="userable[jobTitles][${datarecord.id}][verification_status_id]" class="custom-control-label unverified" style="">${jsVars.pendingStatusLabel}</label>
                </div>
            </div>
        `;
    }

    priceColumn(datarecord) {
        return `
            <span class="select-label">${jsVars.currentPricingText} <i class="far fa-question-circle" data-toggle="tooltip" title="${jsVars.priceNotSetLabel}"></i></span>
            <input name="userable[jobTitles][${datarecord.id}][rate]" type="hidden">
            <input name="userable[jobTitles][${datarecord.id}][candidate_rate]" type="hidden">
            <input name="userable[jobTitles][${datarecord.id}][rate_files]" type="hidden" value="[]">
        `;
    }

    initProfessionsDropzone() {
        this.$jobTitleFiles = $('#job-title-files-dropzone');

        // Every time modal hides
        this.$professionsEditModal.on('hidden.bs.modal', function (e) {
            this.$jobTitleFiles.get(0).dropzone.destroy();
        }.bind(this));

        // Every time modal is opened
        this.$professionsEditModal.on('show.bs.modal', function (e) {
            if (this.$jobTitleFiles.hasClass('dropzone') && this.$jobTitleFiles.get(0).dropzone) {
                this.$jobTitleFiles.get(0).dropzone.destroy();
            }
            this.$jobTitleFiles.addClass('dropzone');
            let jobTitleId = this.$jobTitleFiles.parents('.modal').find('[name="job_title_id"]').val();
            this.$jobTitleFiles.dropzone(
                {
                    url: jsVars.saveRateFilesUrl.replace(':job-title-id', jobTitleId),
                    init: function () {
                        let thisDropzone = this;
                        let $thisElement = $(thisDropzone.element);

                        thisDropzone.inputField = $thisElement.find('input');
                        thisDropzone.modelId = $thisElement.parents('.modal').find('[name="job_title_id"]').val();
                        thisDropzone.modelId = typeof thisDropzone.modelId === "undefined" ? '' : thisDropzone.modelId;

                        thisDropzone.preloadedFiles = [];
                        if (thisDropzone.inputField.length !== 0) {
                            thisDropzone.preloadedFiles = thisDropzone.inputField.val();
                            thisDropzone.preloadedFiles = JSON.parse(thisDropzone.preloadedFiles);
                        }

                        $.each(thisDropzone.preloadedFiles, function (key, value) {
                            if (!value) {
                                return;
                            }
                            let file = {
                                processing: true,
                                accepted: true,
                                name: value.originalName,
                                size: value.size,
                                type: value.mimeType,
                                status: Dropzone.SUCCESS,
                                downloadLink: value.path,
                                dbData: value,
                            };
                            thisDropzone.files.push(file);
                            thisDropzone.emit("addedfile", file);
                            if (value.thumbnail) {
                                thisDropzone.emit("thumbnail", file, Laravel.app_url + value.thumbnail);
                            }
                            thisDropzone.emit("processing", file);
                            thisDropzone.emit("success", file, {status: "success"}, false);
                            thisDropzone.emit("complete", file);
                            file.path = value.path;
                        });

                        $thisElement.on('click', '[data-dz-name]', function (e) {
                            let $target = $(e.target);
                            let $fileContainer = $target.parents('.dz-preview');
                            let downloadLink = $fileContainer.find('.dz-file-download-link').val();

                            window.open(Laravel.app_url + '/storage/' + downloadLink, '_blank');
                        });

                        thisDropzone.on("removedfile", function (file) {
                            this.inputField.val(JSON.stringify(this.files.map(a => a.dbData)));
                        });

                        thisDropzone.on("addedfile", function (file) {
                            $thisElement.parents('.modal').find('button').prop('disabled', true);
                        });

                        thisDropzone.on("complete", function (file) {
                            $thisElement.parents('.modal').find('button').prop('disabled', false);
                        });
                    },
                    sending: function (file, xhr, formData) {
                        formData.append("_token", Laravel.csrfToken);
                        formData.append("id", this.modelId);
                    },
                    success: function (file, response) {
                        if (typeof response.uploadedFile !== "undefined") {
                            // This is an ajax response
                            file.path = response.uploadedFile.path;
                            file.dbData = response.uploadedFile;
                            this.inputField.val(JSON.stringify(this.files.map(a => a.dbData)));
                        }
                        let link = file.downloadLink || file.path;
                        if (link) {
                            // Save download link to hidden input for click to open to work
                            file.previewTemplate.insertAdjacentHTML('beforeend',
                                `<input type="hidden" class="dz-file-download-link" value="${link}" />`);
                        }
                        if (typeof response.uploadedFile !== "undefined") {
                            $(file.previewElement).addClass("dz-success");
                            setTimeout(function () {
                                $(file.previewElement).removeClass("dz-success");
                            }, 2750);

                            Dashmix.helpers('notify', {
                                align: 'center',
                                type: 'success',
                                icon: 'fa fa-check mr-1 mt-5 mb-5',
                                message: jsVars.fileUploadedSuccessTab
                            });
                        }
                    },
                    error: function (file, message) {
                        $(file.previewElement).addClass("dz-error");
                        if (message.errors) {
                            $(file.previewElement).find('.dz-error-message').text(message.errors.file);
                        }
                    },
                    addRemoveLinks: true,
                }
            );
        }.bind(this));
    }

    initDisableUserButtons() {
        let $form = $('#toggle-disabled-user');

        let e = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        $('.enable-user-button').on("click", (function (n) {
            n.preventDefault();
            e.fire({
                title: jsVars.confirmText,
                text: jsVars.confirmEnableText,
                icon: "warning",
                showCancelButton: true,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-outline-primary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {
                    return $form.submit();
                }
            }).then((function (n) {
                n.value ?
                    swal.fire(jsVars.confirmActionSuccess, '', "success") && $modal.modal('hide') :
                    "cancel" === n.dismiss;
            }))
        }));

        $('.disable-user-button').on("click", (function (n) {
            n.preventDefault();
            e.fire({
                title: jsVars.confirmText,
                text: jsVars.confirmDisableText,
                icon: "warning",
                showCancelButton: true,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {
                    return $form.submit();
                }
            }).then((function (n) {
                app.reloadAfterCloseModal = true;
                n.value ?
                    swal.fire(jsVars.confirmActionSuccess, '', "success") && $modal.modal('hide') :
                    "cancel" === n.dismiss;
            }))
        }));

        let $formReset = $('#reset-user');

        $('.reset-user-button').on("click", (function (n) {
            n.preventDefault();
            e.fire({
                title: jsVars.confirmText,
                text: jsVars.confirmResetText,
                icon: "warning",
                showCancelButton: true,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {
                    return $formReset.submit();
                }
            }).then((function (n) {
                n.value ?
                    swal.fire(jsVars.confirmActionSuccess, '', "success") && window.parent.location.reload() :
                    "cancel" === n.dismiss;

            }))
        }));


    }
}
